var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlataformaDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 24,
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Plataforma",
    d: "M-1660-3423a1,1,0,0,1-1-1v-1a1,1,0,0,1,1-1h34a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1Zm5-3a3.009,3.009,0,0,1-3-3v-15a3.009,3.009,0,0,1,3-3h24a3.009,3.009,0,0,1,3,3l-.015,15a3,3,0,0,1-2.984,3Zm0-3h24v-15h-24Z",
    transform: "translate(1661 3447)",
    fill: "#F8F4FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlataformaDark);
export default __webpack_public_path__ + "static/media/PlataformaDark.a4a56573d77b51617fd511d25f30e47b.svg";
export { ForwardRef as ReactComponent };